import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class Base extends PureComponent {
    // https://github.com/reactjs/react-tabs/blob/master/lib%2Fhelpers%2FchildrenPropType.js
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.bool]),
    }

    render() {
        return <Fragment>{this.props.children}</Fragment>
    }
}
